<div class="benefits-block {{classess}}" [class.discount-block]="darkMode"
  [class.single-benefit-styles]="singleBenefitStyles">

  @if (benefits.returnWarranityDays) {
  <div class="benefit-line">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="archive-arrow-down-outline 2">
        <path id="Vector"
          d="M16.6667 17.5H3.33333V8.33333H5V15.8333H15V8.33333H16.6667V17.5ZM2.5 2.5H17.5V7.5H2.5V2.5ZM4.16667 4.16667V5.83333H15.8333V4.16667"
          fill="black" />
        <path id="Vector_2"
          d="M12.833 10.0833L10.333 10.0833L10.333 8L6.99967 11.3333L10.333 14.6667L10.333 12.5833L12.833 12.5833"
          fill="black" />
      </g>
    </svg>
    <span class="benefit-description">{{benefits.returnWarranityDays}}-Day Return Warranty*</span>
  </div>
  }


  @if (benefits.yearlyWarranity) {
  <div class="benefit-line">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="shield-half-full 1">
        <path id="Vector"
          d="M17.5 9.16537C17.5 13.7904 14.3 18.1154 10 19.1654C5.7 18.1154 2.5 13.7904 2.5 9.16537V4.16536L10 0.832031L17.5 4.16536V9.16537ZM10 17.4987C13.125 16.6654 15.8333 12.9487 15.8333 9.3487V5.2487L10 2.6487V17.4987Z"
          fill="black" />
      </g>
    </svg>
    <span class="benefit-description">{{benefits.yearlyWarranity}}-Year Warranty</span>
  </div>
  }
  @if (benefits.nonReturnable) {
  <div class="benefit-line">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="archive-arrow-down-outline 1">
        <path id="Vector"
          d="M16.6667 17.5H3.33333V8.33333H5V15.8333H15V8.33333H16.6667V17.5ZM2.5 2.5H17.5V7.5H2.5V2.5ZM4.16667 4.16667V5.83333H15.8333V4.16667"
          fill="black" />
        <path id="Vector_2"
          d="M12.833 10.0833L10.333 10.0833L10.333 8L6.99967 11.3333L10.333 14.6667L10.333 12.5833L12.833 12.5833"
          fill="black" />
      </g>
    </svg>
    <span class="benefit-description">Non-Returnable</span>
  </div>
  }

  @if (benefits.shippingWeeksMin || benefits.shippingWeeksMax) {
  <div class="benefit-line">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="flight_takeoff">
        <mask id="mask0_303_1630" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
          <rect id="Bounding box" width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_303_1630)">
          <path id="flight_takeoff_2"
            d="M2.49935 17.5013V15.8346H17.4993V17.5013H2.49935ZM4.04102 13.3346L1.66602 9.29297L2.95768 9.04297L4.41602 10.3346L8.41602 9.2513L5.04102 3.54297L6.66602 3.04297L12.3743 8.16797L16.541 7.04297C16.9855 6.91797 17.3882 7.0013 17.7493 7.29297C18.1105 7.58464 18.291 7.97352 18.291 8.45964C18.291 8.76519 18.1973 9.03602 18.0098 9.27214C17.8223 9.50825 17.5827 9.66797 17.291 9.7513L4.04102 13.3346Z"
            fill="#1C1B1F" />
        </g>
      </g>
    </svg>
    <span class="benefit-description">{{benefits.shippingWeeksMin}}-{{benefits.shippingWeeksMax}} weeks</span>
  </div>
  }



</div>
